export default {
     //request_url:'http://localhost/api/',
   request_url:'https://lsadmin.jobgroup.cn/api/',
}



//////////////////
// WEBPACK FOOTER
// ./static/conf.js
// module id = null
// module chunks = 